import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import TableActions from '../../../../components/TableActions';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetMeetingListPagingAndFilterRequest } from '../../../../models/request/meeting/GetMeetingListPagingAndFilterRequest';
import { GetMeetingListPagingAndFilterResponseData } from '../../../../models/response/meeting/GetMeetingListPagingAndFilterResponse';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetMeetingListPagingAndFilterRequest
    getData: (_filter?: GetMeetingListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetMeetingListPagingAndFilterRequest>>
    data: GetMeetingListPagingAndFilterResponseData
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const MeetingListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    data,
    selectedCount,
    deleteFunction,
    onSearchSubmit,
    updateFunction
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <TableActions
                list={[
                    {
                        onClick: () => navigate('/antrepooffer/listadd?meetingId=' + data.items.filter(x => x.isSelected)[0].meetingId),
                        text: 'Teklif Oluştur',
                        isDisabled: data.items.filter(x => x.isSelected).length != 1
                    }
                ]}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Görüşme Tarihi, Müşteri, Görüşme Şekli
                ve Firma Durumu kolon başlığının altındaki filtrede var (tarih ve firma durumu
                varsayılanları açılışta kolon filtresi olarak kurulur). */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/meeting/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Görüşme Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default MeetingListFilters;